<template>
  <!-- 사용자 정보 -->
  <div class="user-info-wrap"><!-- login-before, login-after -->
    <!-- 로그인 전 -->
    <div v-if="!isLogin" class="user-info-item login-before">
      <p class="s-txt">
        닥터인포에 로그인하여
      </p>
      <p class="b-txt">
        이달의 미션 포인트를 쌓아보세요!
      </p>
      <button class="btn-login" @click="login()">
        로그인
      </button>
    </div>
    <!-- 로그인 후 -->
    <div v-if="isLogin" class="user-info-item login-after">
      <p class="s-txt">
        환영합니다!
      </p>
      <p class="b-txt">
        <span class="user-name">{{ userName }}</span>선생님의 보유 포인트
      </p>

      <p class="user-point">
        <span class="point">{{ userPoint | $numberFormatter }}</span><em>P</em>
      </p>
    </div>

    <hr class="line-1">

    <!-- 이달의 미션 -->
    <div class="user-info-item mission-wrap">
      <h3>이달의 미션</h3>
      <ul>
        <li class="medical-type">
          <span class="left-col">
            <span class="mission-type">메디컬 트렌드</span>
            <span class="mission-goal">댓글 {{ mediReply.goal }}개 작성</span>
          </span>
          <span class="right-col">
            <span v-if="isLogin" class="mission-status"><em>{{ mediReply.my }}</em> / {{ mediReply.goal }}</span>
            <span v-else class="mission-point">{{ mediReply.point | $numberFormatter }}<em>P</em></span>
          </span>
        </li>
        <li class="seminar-type">
          <span class="left-col">
            <span class="mission-type">웹세미나</span>
            <span class="mission-goal">{{ webinarView.goal }}회 일정 등록</span>
          </span>
          <span class="right-col">
            <span v-if="isLogin" class="mission-status"><em>{{ webinarView.my }} </em> / {{ webinarView.goal }}</span>
            <span v-else class="mission-point">{{ webinarView.point | $numberFormatter }}<em>P</em></span>
          </span>
        </li>

        <li class="weekly-type">
          <span class="left-col">
            <span class="mission-type">Weekly Choice</span>
            <span class="mission-goal">{{ wChoice.goal }}회 참여</span>
          </span>
          <span class="right-col">
            <span v-if="isLogin" class="mission-status"><em>{{ wChoice.my }}</em> / {{ wChoice.goal }}</span>
            <span v-else class="mission-point">{{ wChoice.point | $numberFormatter }}<em>P</em></span>
          </span>
        </li>
      </ul>
    </div>

    <hr class="line-1">

    <div class="user-info-item survey-wrap"
         @click="link('app-survey-main')"
    >
      <h3>참여 가능한 설문조사</h3>
      <span class="survey-status">{{ surveyCount }}<em>건</em></span>
    </div>
  </div>
  <!-- //사용자 정보 -->

</template>

<script>
import { mapGetters } from 'vuex'
import { clearUserData, getUserData, isUserLoggedIn } from '@/auth/utils'
import axios from '@axios'
import { SNT } from '@/core/global/global-enums'
import { setStatisticsNew } from '@/common/statistics/service'

export default {
  data() {
    return {
      isLogin: null,
      surveyCount: 0,

      missions: [],
      drugReply: {
        my: 0,
        goal: 0,
        point: 0,
        rate: 0,
        complete: false,
      },
      mediReply: {
        my: 0,
        goal: 0,
        point: 0,
        rate: 0,
        complete: false,
      },
      webinarView: {
        my: 0,
        goal: 0,
        point: 0,
        rate: 0,
        complete: false,
      },
      wChoice: {
        my: 0,
        goal: 0,
        point: 0,
        rate: 0,
        complete: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      userName: 'account/getName',
      userPoint: 'account/getPoint',
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      shaYoyangNum: 'infoData/getShaYoyangNum',
      shaEnLicenseNum: 'infoData/getShaEnLicenseNum',
    })
  },
  watch: {
    userName(val) {
      if (val === null) {
        this.isLogin = false
      } else {
        this.isLogin = true
      }
    },
    isLogin() { // userName 이 created 이후 변경되는 경우(ShowInTaskbar = false 였을 때)가 있어 isLogin watch 추가
      this.getSurvey()
      this.fetchMonthMission()
    },
  },
  async created() {
    this.routeName = this.$route.name

    if (this.userName !== null) {
      this.isLogin = true
    } else {
      await this.checkLogin()
    }
    // this.getSurvey()
    // this.fetchMonthMission()
  },
  methods: {
    async checkLogin() {
      this.isLogin = await isUserLoggedIn()

      if (this.isLogin) {
        const user = getUserData()
        this.$store.commit('account/setName', user.userName)
        this.$store.commit('account/setPoint', user.userPoint)
      }
    },
    login() {
      this.$router.push({ name: 'login-main' }).catch(() => {})
    },
    logout() {
      clearUserData()

      this.isLogin = false
    },

    getSurvey() {
      axios.post('/fu/dashboard/surveys', {
        medicalDept: this.medicalDept,
        region: this.region,
        shaYoyangNum: this.shaYoyangNum,
        shaEnLicenseNum: this.shaEnLicenseNum,
      })
        .then(rs => {
          this.surveyCount = rs.data.joinAbleCount
          this.survey = rs.data.survey
        })
        .catch(error => {
          this.showAlertDialog(error.response.data)
        })
    },

    missionSetting(data, category) {
      const mission = data.find(x => x.category === category)
      if (mission == null) return null

      return {
        my: mission.count,
        goal: mission.goal,
        point: mission.point,
        rate: mission.complete ? 100 : (mission.count >= mission.goal ? 100 : Math.round((mission.count / mission.goal) * 100)),
        complete: mission.complete
      }
    },
    fetchMonthMission() {
      if (this.isLogin) {
        axios.get('/fu/point-history/mission') // 회원 전용
          .then(rs => {
          // this.drugReply = this.missionSetting(rs.data, 12)
            this.mediReply = this.missionSetting(rs.data, 13)
            this.webinarView = this.missionSetting(rs.data, 14)
            this.wChoice = this.missionSetting(rs.data, 16)
          })
      } else {
        axios.get('/fu/dashboard/mission') // 비회원 공용
          .then(rs => {
          // this.drugReply = this.missionSetting(rs.data, 12)
            this.mediReply = this.missionSetting(rs.data, 13)
            this.webinarView = this.missionSetting(rs.data, 14)
            this.wChoice = this.missionSetting(rs.data, 16)
          })
      }
    },

    link(route) {
      let serviceType = ''; let positionType = ''; let stateType = ''
      const ROUTE_DATA_MAP = {
        // 'app-main': { // 기존통계: 200
        //   serviceType: SNT.A.Service_컨텐츠__복합,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_닥터인포,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
        // 'app-medical-trend-main': { // 기존통계: 201
        //   serviceType: SNT.A.Service_컨텐츠__메디컬트렌드,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_메디컬트렌드,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
        // 'app-druginfo-main': { // 기존통계: 202
        //   serviceType: SNT.A.Service_컨텐츠__약품정보,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_약품정보,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
        // 'app-webseminar-client': { // 기존통계: 203
        //   serviceType: SNT.A.Service_컨텐츠__웹세미나,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_웹심포지엄,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
        'app-survey-main': { // 기존통계: 204
          serviceType: SNT.A.Service_컨텐츠__설문조사,
          positionType: SNT.B.Position_닥터인포__메인____Body____홈__사용자정보,
          stateType: SNT.C.State_Action__클릭_컨텐츠,
        },
        // 'app-event-main': { // 기존통계: 205
        //   serviceType: SNT.A.Service_컨텐츠__이벤트,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_이벤트,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
        // 'app-notice-main': { // 기존통계: 206
        //   serviceType: SNT.A.Service_컨텐츠__공지사항,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_공지사항,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
        // 'app-point-mall-main': { // 기존통계: 207
        //   serviceType: SNT.A.Service_인증__계정,
        //   positionType: SNT.B.Position_닥터인포__메인____Header____GNB_포인트몰,
        //   stateType: SNT.C.State_Action__클릭_컨텐츠,
        // },
      }

      const routeData = ROUTE_DATA_MAP[route]
      if (routeData) {
        ({ serviceType, positionType, stateType } = routeData)
        setStatisticsNew(serviceType, positionType, stateType, 0) // 메뉴 진입 통계
      }

      this.$router.push({ name: route }).catch(() => {})
    },
  }
}
</script>
